'use client';

import { type Path, type PathValue, useWatch } from 'react-hook-form';

import { IS_SSR } from '@libs/common-next';

import type { FormFields } from './formTypes';
import { purchaseFormCtx } from './purchaseFormCtx';

/**
 * Watch a specific field in the purchase form
 *
 * @param name
 * @returns The current value of the field, or undefined if not set
 *
 * @example
 * const quantity = usePurchaseFormWatch('quantity');
 * const colorStyle = usePurchaseFormWatch('personalization.colorStyle');
 */
export function usePurchaseFormWatch<Name extends Path<FormFields>>(
    name: Name
): PathValue<FormFields, Name> | undefined {
    const value = useWatch<FormFields, Name>({ name, control: purchaseFormCtx.control });

    return (IS_SSR ? undefined : value) as PathValue<FormFields, Name> | undefined;
}
